module.exports = __webpack_public_path__ + "img/aud.da963d93.svg";